import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate  = useNavigate();

  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate('/leagues', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src="/logo.png" alt="RotatePlay" style={{ height: '8rem', objectFit: 'contain' }} />
          <div style={{ fontSize: '0.8rem', color: 'var(--muted)', marginTop: 6, letterSpacing: '0.06em', textTransform: 'uppercase' }}>
            Pickleball League Manager
          </div>
        </div>

        <div className="card">
          <div className="card-title">Organizer Sign In</div>

          {error && <div className="alert alert-red">{error}</div>}

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div>
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
                required
                style={{ marginTop: 4 }}
              />
            </div>
            <div>
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="current-password"
                required
                style={{ marginTop: 4 }}
              />
            </div>

            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>

          <div style={{ marginTop: 16, fontSize: '.875rem', display: 'flex', flexDirection: 'column', gap: 6 }}>
            <Link to="/forgot-password" style={{ color: 'var(--blue)' }}>Forgot password?</Link>
            <span>
              No account?{' '}
              <Link to="/signup" style={{ color: 'var(--blue)' }}>Create one</Link>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
